import { useEffect, useState } from 'react';

export const useShowContactsFilters = () => {
  const [filtersVisible, setFiltersVisible] = useState(false);

  useEffect(() => {
    window.addEventListener('onShowContactsFilters', () => {
      setFiltersVisible(true);
    });
  }, []);

  return { filtersVisible, setFiltersVisible };
};
